import { app } from '../../../bootstrap/core';
import { normalizeErrorMessageKey, ErrorReasons } from './errorReasons';

app.run((errorService, notificationService, errorTrackingService) => {
  'ngInject';

  // Try to improve error messages by guessing
  // the reason of that error with conditional
  // checks and assumptions.
  const guessErrorReason = (err) => {
    // Handle multiple errors
    if (err.errors) {
      return err.errors.map((message) => guessErrorReason({ message }));
    }

    // store original http error message to use for further processing
    err.originalMessage = err.message;

    // If the error contains a status code, we can
    // try to specify the reason by that code.
    const statusCode = err.code || parseInt(err.status);
    switch (statusCode) {
      case -1: {
        // Connection refused
        err.message = ErrorReasons.connectionRefused;
        break;
      }
      case 400: {
        // Bad request
        err.message = ErrorReasons.badRequest;
        break;
      }
      case 401: {
        // Unauthorized
        err.message = ErrorReasons.unauthorized;
        break;
      }
      case 403: {
        // Forbidden
        err.message = ErrorReasons.forbidden;
        break;
      }
      case 409: {
        // Conflict - handled explicitly by the caller (e.g. ticket reload on stale state)
        return null;
      }
      case 412: {
        // Forbidden
        // Try to detect the explicit failure reason by parts of the request url
        if (err.url && err.url.indexOf('/documents/') !== -1) {
          err.message = ErrorReasons.preconditionFailedWrongIban;
          break;
        }

        err.message = ErrorReasons.preconditionFailed;
        break;
      }
      case 413: {
        err.message = ErrorReasons.entityTooLarge;
        break;
      }
      case 500: {
        // Internal Error
        err.message = ErrorReasons.internalError;
        break;
      }
      default: {
        // Get error reason by message key
        // or normalize default error messages.
        err.message =
          ErrorReasons[err.message] || normalizeErrorMessageKey(err.message);
      }
    }

    return err;
  };

  // Bind the notificationService to the errorService events
  errorService.onError((errors) => {
    // NOTE: The errorService delivers the errors as an array
    if (errors) {
      errors.map((err) => {
        // Show Error Message to User
        const reason = guessErrorReason(err);
        // Handle multiple error reasons
        if (angular.isArray(reason)) {
          reason.forEach((error) => {
            notificationService.error(error.message, error.err, error.title);
          });
        } else if (reason) {
          const { message, title } = reason;
          notificationService.error(message, err, title);
        }
      });
    }
  });
});
